import { pricing } from "@/framework/billing/resourcePricing";
import Typography from "@mui/material/Typography";
import { css } from "@emotion/css";
import { Section } from "../../landing-page/Section";
import { minimumTopupEur } from "@/framework/billing/topup/topupAmounts";
import { CreditValuePickerWithDetails } from "@/modules/billing/pricing/CreditValuePicker";
import { CreditAmountPickerState } from "@/modules/billing/pricing/CreditAmountPickerState";
import { PricingCallToAction } from "@/modules/billing/pricing/PricingCallToAction";
import Box from "@mui/material/Box";
import { useState } from "react";

const Blocks = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 4 }}
      component="div"
      className="blocks"
    >
      {children}
    </Box>
  );
};
const Block = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box component="div" className="block">
      {children}
    </Box>
  );
};

export const PricingContent = () => {
  // Owned here so both the picker and the topup link see the same selection.
  const [pickerState] = useState(() => new CreditAmountPickerState());
  return (
    <Blocks>
      <Block>
        <Typography component="p" sx={{ mb: 2 }}>
          Top up a minimum of {minimumTopupEur} credits which you can use for
          transcription, translation and dictionary lookups.
        </Typography>
      </Block>

      <Block>
        <RatesList />
      </Block>

      <Block>
        <Typography variant="h5" sx={{ mb: 1 }} component="h4">
          What your topup buys
        </Typography>

        <CreditValuePickerWithDetails state={pickerState} />

        <Box sx={{ mt: 4 }}>
          <PricingCallToAction state={pickerState} />
        </Box>
      </Block>
    </Blocks>
  );
};

// Per-unit rates, straight from the shared pricing config.
const RatesList = () => (
  <>
    <Typography component="p" sx={{ mb: 1 }}>
      {pricing.transcribed_hour.credits} credits per hour of transcribed audio,
      billed proportionally by the second.
    </Typography>
    <Typography component="p" sx={{ mb: 1 }}>
      {pricing.translated_thousand_characters.credits} credits per thousand
      translated characters, billed by the character.
    </Typography>
    <Typography component="p" sx={{ mb: 1 }}>
      {pricing.dictionary_lookup.credits} credits per dictionary lookup, free
      for German to English lookups.
    </Typography>
    <Typography component="p" sx={{ mt: 2 }}>
      1 credit costs 1 € + any applicable VAT.
    </Typography>
  </>
);
